import api from "./api";

export function getForexServicePage(country_id) {
  return api.get(`/forexexchange/${country_id}`);
}

export function getForexServiceData(country_id) {
  return api.get(`/forexservice/dropdown?country_id=${country_id}`);
}

export function getForexExchangeData() {
  return api.get(`/forexorder/forexexchangedata`);
}

export function submitForex(data) {
  return api.post(`/forexorder`, data);
}